import React from 'react';
import PropTypes from 'prop-types';
import { FileUploadButton } from 'react-file-utils';

import {
  FileUploadButtonContainer,
  FileAttachmentIcon,
} from './styles';

const FileAttachmentButton = ({
  onFileUpload,
  isDisabled,
}) => (
  <FileUploadButtonContainer data-testid="attach-file-button">
    <FileUploadButton disabled={isDisabled} handleFiles={onFileUpload}>
      <FileAttachmentIcon />
    </FileUploadButton>
  </FileUploadButtonContainer>
);

FileAttachmentButton.propTypes = {
  onFileUpload: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};
FileAttachmentButton.defaultProps = {
  isDisabled: false,
};

export default FileAttachmentButton;
